


































































import { Vue, Component } from "vue-property-decorator";
// import ReportApi from "@/api/Report";
// import ModelFactory from "@/model/ModelFactory";

import AdminStatus from "./AdminStatus.vue";
import AdminCharts from "./AdminCharts.vue";
import AdminData from "./AdminData.vue";
import AdminDetails from "./AdminDetails.vue";

import XlsApi from "@/api/Xls";
import ReportApi from "@/api/Report";
import ModelFactory from "@/model/ModelFactory";
import StatusModel from "@/model/Status";

@Component({
  name: "Admin",
  components: {
    AdminStatus,
    AdminCharts,
    AdminData,
    AdminDetails
  }
})
export default class Admin extends Vue {
  public interval: any = null;
  public statusUrl = XlsApi.getStatusUrl();
  public beneficiaryUrl = XlsApi.getBeneficiaryUrl();
  public hcpIndUrl = XlsApi.getHcpIndUrl();
  public yearlyUrl = XlsApi.getYearlyUrl();
  public allReportsZipUrl = XlsApi.getAllReportsZipUrl();
  public allReportsUrl = XlsApi.getAllReportsUrl();
  public allPreliminaryReportsUrl = XlsApi.getAllPreliminaryReportsUrl();
  public allPreliminaryReportsZipUrl = XlsApi.getAllPreliminaryReportsZipUrl();

  public data: {} = {
    summary: {},
    details: [],
    status: []
  };
  public year: number = 0;

  mounted() {
    this.interval = setInterval(() => this.getData(), 1000 * 60 * 5);
    this.getData();
  }

  destroyed() {
    clearInterval(this.interval);
  }

  async getData() {
    const data = await ReportApi.getSummary(this.year).then((res: any) => res);
    Vue.set(this.data, "summary", data.summary);
    Vue.set(this.data, "details", data.details);

    const status = await ReportApi.getStatus().then((res: StatusModel) => res);

    Vue.set(this.data, "status", ModelFactory.create("StatusModel", status));
  }
}
